<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10sdKPC/tc-custom/9781504027311.jpg?1734197234064" alt="This image is the cover for the book Toll Call, The John Marshall Tanner Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Toll Call, The John Marshall Tanner Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>John Marshall Tanner will go above and beyond to protect his secretary from a stalker</b><br/><br/> John Marshall Tanner finds his secretary slumped over on the sofa, her arm draped across her face. This private eye has seen enough death that, for a moment, he thinks Peggy Nettleton has been murdered. Fortunately, after a moment’s panic, he realizes she has simply dozed off. Tanner has worked alongside Peggy for eight years, and if something happened to her, it would shatter him. Unfortunately, that grim nightmare is about to come true.<br/>  <br/> For weeks now, Peggy has been getting obscene phone calls from one of the most deranged minds in San Francisco. To set her mind at rest, Tanner goes looking for the caller—a decision that sends him down a path of madness and murder that could either push him into Peggy’s arms or separate them forever.<br/>  <br/><i>Toll Call</i> is the 6th book in the John Marshall Tanner Mysteries, but you may enjoy reading the series in any order.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stephen Greenleaf
      </h2>
      
      <p class="authorDescription body article">Stephen Greenleaf (b. 1942), a former lawyer and an alumnus of the prestigious Iowa Writer&rsquo;s Workshop, &#160;is a mystery and thriller writer &#160;best known for his series of novels starring PI John Marshall Tanner. Recognized for being both literate and highly entertaining, Greenleaf&rsquo;s novels often deal with contemporary social and political issues.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0fa5d307